import { useMemo, useState } from "react";

const recipientEmail = "dolapoolakanmi@gmail.com";

function MakeEnquiry() {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const mailtoLink = useMemo(
    () =>
      `mailto:${recipientEmail}?subject=${encodeURIComponent(
        title.trim() || "Enquiry",
      )}&body=${encodeURIComponent(message.trim())}`,
    [message, title],
  );

  return (
    <div className="mt-12 rounded-3xl border border-white/10 bg-[#1d1d1d] p-6 shadow-xl shadow-black/20 md:p-8">
      <div className="mb-6 text-center md:text-left">
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#fbbf24]">
          Enquiry
        </p>
        <h3 className="mt-2 text-2xl font-bold text-white md:text-3xl">
          Send a message
        </h3>
      </div>

      <div className="grid gap-5">
        <label className="block">
          <span className="mb-2 block text-sm font-medium text-slate-200">
            Title
          </span>
          <input
            type="text"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            placeholder="Enter title"
            className="w-full rounded-xl border border-white/10 bg-[#2a2a2a] px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#fbbf24] focus:outline-none"
          />
        </label>

        <label className="block">
          <span className="mb-2 block text-sm font-medium text-slate-200">
            Message
          </span>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            rows={5}
            placeholder="Enter your message..."
            className="w-full rounded-xl border border-white/10 bg-[#2a2a2a] px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#fbbf24] focus:outline-none"
          />
        </label>
      </div>

      <div className="mt-6 flex justify-end border-t border-white/10 pt-4">
        <a
          href={mailtoLink}
          className="inline-flex items-center justify-center rounded-xl bg-[#fbbf24] px-5 py-3 text-sm font-semibold text-[#1d1d1d] transition hover:bg-[#facc15]"
        >
          Send enquiry
        </a>
      </div>
    </div>
  );
}

export default MakeEnquiry;
